import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChangeNote } from '../_models/change-note.model';
import { BaseServiceClass } from './baseService.service';

@Injectable({ providedIn: 'root' })
export class ChangeNoteService extends BaseServiceClass<ChangeNote> {
  constructor(protected http: HttpClient) {
    super(http, '/api/v1/change-notes');
  }

  /**
   * Busca uma Change Note por versão
   * GET /change-notes/version/{version}
   */
  public getByVersion(version: string): Observable<ChangeNote> {
    return this.http.get<ChangeNote>(`${this.entity_url}/version/${version}`);
  }

  /**
   * Busca uma Change Note por ID
   * GET /change-notes/{id}
   */
  public getById(id: number): Observable<ChangeNote> {
    return this.http.get<ChangeNote>(`${this.entity_url}/${id}`);
  }
}
